"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.traceIdMomentUrl = void 0;

var traceIdMomentUrl = function traceIdMomentUrl(profileHash, collectionHash, playlistClipId, opts) {
  var url = process.env.REACT_APP_TRACE_ID;

  if (opts && opts.traceid_v2 && collectionHash) {
    url = process.env.REACT_APP_TRACE_ID_BETA;
    return "".concat(url, "/athlete/").concat(profileHash, "/list/").concat(collectionHash, "/item/").concat(playlistClipId);
  }

  return "".concat(url, "/athlete/").concat(profileHash, "/moments/").concat(playlistClipId);
};

exports.traceIdMomentUrl = traceIdMomentUrl;